export default function snakeToTitle(s) {
    return s.replace(/^_*(.)/, (_, c) => c.toUpperCase())       // First non-underscore char
        .replace(/_+(.)/g, (_, c) => ' ' + c.toUpperCase()) // First non-underscore char after each _
}
